import { render } from "./Castells-View.vue?vue&type=template&id=10b06ff8&scoped=true"
import script from "./Castells-View.vue?vue&type=script&lang=js"
export * from "./Castells-View.vue?vue&type=script&lang=js"

import "./Castells-View.vue?vue&type=style&index=0&id=10b06ff8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b06ff8"]])

export default __exports__